@file:OptIn(InternalResourceApi::class)

package realrate.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/realrate.shared.generated.resources/"

@delegate:ResourceContentHash(-661_831_935)
internal val Res.font.NotoSans: FontResource by lazy {
      FontResource("font:NotoSans", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_137_753_549)
internal val Res.font.NotoSansArabic: FontResource by lazy {
      FontResource("font:NotoSansArabic", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansArabic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(522_201_902)
internal val Res.font.NotoSansBengali: FontResource by lazy {
      FontResource("font:NotoSansBengali", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansBengali.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-645_795_787)
internal val Res.font.NotoSansDevanagari: FontResource by lazy {
      FontResource("font:NotoSansDevanagari", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansDevanagari.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_714_741_031)
internal val Res.font.NotoSansJP: FontResource by lazy {
      FontResource("font:NotoSansJP", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansJP.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-613_685_736)
internal val Res.font.NotoSansKR: FontResource by lazy {
      FontResource("font:NotoSansKR", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansKR.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-745_675_904)
internal val Res.font.NotoSansSC: FontResource by lazy {
      FontResource("font:NotoSansSC", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansSC.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-797_387_352)
internal val Res.font.NotoSansThai: FontResource by lazy {
      FontResource("font:NotoSansThai", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansThai.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("NotoSans", Res.font.NotoSans)
  map.put("NotoSansArabic", Res.font.NotoSansArabic)
  map.put("NotoSansBengali", Res.font.NotoSansBengali)
  map.put("NotoSansDevanagari", Res.font.NotoSansDevanagari)
  map.put("NotoSansJP", Res.font.NotoSansJP)
  map.put("NotoSansKR", Res.font.NotoSansKR)
  map.put("NotoSansSC", Res.font.NotoSansSC)
  map.put("NotoSansThai", Res.font.NotoSansThai)
}
